import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ScreenLayout } from '@qronstat/shared';
import { api } from './client';

export interface StoredLayout {
  layout: ScreenLayout | null;
  updatedAt: string | null;
}

const key = (screen: string) => ['layouts', screen] as const;

export function useScreenLayout(screen: string) {
  return useQuery({
    queryKey: key(screen),
    queryFn: ({ signal }) => api<StoredLayout>(`/api/layouts/${encodeURIComponent(screen)}`, { signal }),
    staleTime: 5 * 60_000,
    meta: { persist: true },
  });
}

export function useLayoutMutations(screen: string) {
  const client = useQueryClient();
  const store = (data: StoredLayout) => client.setQueryData(key(screen), data);
  const save = useMutation({
    mutationFn: (layout: ScreenLayout) =>
      api<StoredLayout>(`/api/layouts/${encodeURIComponent(screen)}`, { method: 'PUT', body: layout }),
    onSuccess: store,
  });
  const reset = useMutation({
    mutationFn: () => api<StoredLayout>(`/api/layouts/${encodeURIComponent(screen)}`, { method: 'DELETE' }),
    onSuccess: store,
  });
  return { save, reset };
}
